import { isNodeLabelExists } from "../../../../../../components/drawing-tool/utils";
import { NodeLabelExistError } from "../../../../../../config/enums/NodeLabelError.enum";
import { PackagingDrawingNode } from "../packagingBase.types";
import { shouldSkipPackagingNameDuplicateCheck } from "../packagingValidation.utils";

export const validatePackagingName = ({
  packagingName,
  existingPackagingName,
  chartNodes
}: {
  packagingName: string;
  existingPackagingName: string;
  chartNodes: PackagingDrawingNode[];
}) => {
  if (
    !shouldSkipPackagingNameDuplicateCheck(existingPackagingName, packagingName) &&
    isNodeLabelExists(chartNodes as never[], packagingName)
  ) {
    return {
      isValid: false as const,
      errorMessage: NodeLabelExistError.PACKAGING
    };
  }

  return { isValid: true as const };
};
